const convertPayloadToQueryParams = (payload) => {
    const cleanPayload = { ...payload };
    Object.keys(cleanPayload).forEach((key) => {
        if (cleanPayload[key] === '') {
            delete cleanPayload[key];
        }
    });
    return new URLSearchParams(cleanPayload).toString();
};
export default convertPayloadToQueryParams;
